import { Injectable } from '@angular/core';

import { GlobalService } from './global.service';
import { Observable } from 'rxjs';

import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'; 
import { retry, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class OperatorService {

  constructor(
    private http: HttpClient,
    private globalService: GlobalService
    ) { }


  getInitPage(token: string): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getOperatorPageURL, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )

  }
  getOperator(token: string): Observable<any>{
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getOperator, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  addOperator(token, operator){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.addOperator, operator, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  getOperatorProfile(token){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.getOperatorProfile, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

  deleteProfile(token, user_id){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.delete<any>(this.globalService.deleteProfile(user_id), httpOptions)
  }

  updateProfile(token, user_id, obj){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.post<any>(this.globalService.updateUser(user_id), obj, httpOptions)
  }

  getDisponibility(token){
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': token
      })
    };
    return this.http.get<any>(this.globalService.operatorDisponibilityURL, httpOptions).pipe(
      retry(1),
      catchError(this.globalService.handleError)
    )
  }

}
